<template>
  <div class="page-wrapper">
    <navbar></navbar>
    <sidebar></sidebar>
    <section class="app-main animatedLeft" :class="{'margin-left-180':sidebar.opened}">
      <div class="container is-fluid is-marginless app-content">
        <levelbar></levelbar>
        <router-view
          class="animated"
          transition="fade"
          transition-mode="out-in">
        </router-view>
      </div>
    </section>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Navbar from './components/common/Navbar';
  import Sidebar from './components/common/Sidebar';
  import Levelbar from './components/common/Levelbar';
  import {mapState, mapActions} from 'vuex';

  export default {
    components: {
      Navbar,
      Sidebar,
      Levelbar
    },
    data(){
      return{
      }
    },
    computed: {
      ...mapState({
        sidebar: state => state.sidebar
      }),
    },
    created(){
      this.setUserInfoByVuex();
    },
    methods:{
      ...mapActions([
        'setUserInfoByVuex'
      ])
    }
  }
</script>

<style lang="less">
  @import './styles/app.less';
  .app-main {
    padding-top: 50px;
  /*transform: translate3d(0, 0, 0);*/

  @include mobile() {
    margin-left: 0;
  }

  }

  .app-content {
    padding: 20px;
  }

  .animated {
    animation-duration: .377s;
  }
  .margin-left-180{
    margin-left: 180px;
  }
  .animatedLeft{
    animation:marginLeft .377s linear;
  }
</style>
